<div class="btn-group" *ngIf="paginationData.pageNumbers && paginationData.pageNumbers.length > 1">
    <ng-container *ngFor="let num of paginationData.pageNumbers">
        <button class="btn btn-xs {{num===selectedPage ? 'btn-active' : ''}}" (click)="onPageChange(num)">{{num}}</button>
    </ng-container>
</div>